import { AssignExaminerRequest, examinerClient, SpeakingSessionExaminerAllocationDto, SpeakingSessionExaminerAvailabilityDto, SpeakingSessionExaminerDto, speakingSessionRoomStructureClient } from 'api/planning';
import { api } from '../api';
import { SPEAKING_SESSION_ROOMS_LIST_QUERY_TAG } from 'store';
import { invalidateOn } from 'utils';

export const speakingSessionRoomStructureApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getExaminers: builder.query<SpeakingSessionExaminerDto[], { speakingSessionId: number }>({
      query: ({ speakingSessionId }) =>
        examinerClient.getExaminers(speakingSessionId)
    }),
    getExaminersAllocations: builder.query<SpeakingSessionExaminerAllocationDto[], { speakingSessionId: number }>({
      query: ({ speakingSessionId }) =>
        examinerClient.getExaminersAllocations(speakingSessionId)
    }),
    getExaminersAvailabilities: builder.query<SpeakingSessionExaminerAvailabilityDto[], { speakingSessionId: number }>({
      query: ({ speakingSessionId }) =>
        examinerClient.getExaminersAvailabilities(speakingSessionId)
    }),
    assignExaminer: builder.mutation<
      void,
      { speakingSessionId: number; speakingSessionRoomId: number; speakingSessionRoomStructureId: number; request: AssignExaminerRequest }
    >({
      query: ({ speakingSessionId, speakingSessionRoomId, speakingSessionRoomStructureId, request }) =>
        speakingSessionRoomStructureClient.assignExaminer(speakingSessionId, speakingSessionRoomId, speakingSessionRoomStructureId, request),
      invalidatesTags: invalidateOn({
        success: [SPEAKING_SESSION_ROOMS_LIST_QUERY_TAG]
      })
    })
  }),
});

export const {
  useGetExaminersQuery,
  useGetExaminersAllocationsQuery,
  useGetExaminersAvailabilitiesQuery,
  useAssignExaminerMutation
} = speakingSessionRoomStructureApi;
